export default __webpack_public_path__ + "static/media/teacher-remote.c86afe01.png";